import { ApolloLink } from "@apollo/client";
const currencyLink = (countryCode)=>new ApolloLink((operation, forward)=>{
        const hs = {};
        if (countryCode && '*' !== countryCode) hs['creh-country'] = countryCode;
        operation.setContext(({ headers = {} })=>({
                headers: {
                    ...headers,
                    ...hs
                }
            }));
        return forward(operation);
    });
const countryPrefixLink = currencyLink;
export default countryPrefixLink;
